/**
 * `/merchandising/styles/$styleId/design/pack` — the Tech Pack screen (PRD
 * design-studio.md story 2): a read-only, paginated document generated from
 * the Style's design revision + its own colour × size grid (ADR-0044).
 * Generation debits AI credits (R13).
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell, requireModule } from "../../../../features/workspace/index.ts";
import { TechPackPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/design/pack")({
  // Design Studio sub-gate — 1.0-withheld. @see docs/adr/0046-withheld-1.0-modules.md
  beforeLoad: requireModule("design-studio"),
  component: TechPackRoute,
});

function TechPackRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Tech pack" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <TechPackPage styleId={styleId} />
    </WorkspaceShell>
  );
}
